export default __webpack_public_path__ + "static/media/ic-left-arrow.08800154.svg";